
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'redo': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.46 9',
    data: '<path pid="0" d="M16.86 3.6A10.464 10.464 0 0 0 9.96 1 10.492 10.492 0 0 0 0 8.22L2.36 9a8 8 0 0 1 7.6-5.5 7.974 7.974 0 0 1 5.12 1.88L11.46 9h9V0z" _fill="#d9d9d9"/>'
  }
})
